import { createAsyncTypes } from '../utils';

export const CLIENT_CODE_LIST = createAsyncTypes('CLIENT_CODE_LIST');
export const CLIENT_CODE_SET = createAsyncTypes('CLIENT_CODE_SET');

export const CLIENT_CODE_VALIDATION_ERROR = 'CLIENT_CODE_VALIDATION_ERROR';
export const CLIENT_CODE_VALIDATION_SUCCESS = 'CLIENT_CODE_VALIDATION_SUCCESS';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/clientCodeActionTypes.js